import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AuthorizationProvider, useAuthorization } from './contexts/AuthorizationContext';
import { useAuth } from './contexts/AuthContext';
import RootLayout from './components/layout/RootLayout';
import Login from './components/login/Login';
import About from './components/about/About';
import Dashboard from './components/dashboard/Dashboard';
import Forms from './components/forms/Forms';
import Management from './components/manage/Management';
import Waste from './components/waste/Waste';
import ViewForm from './components/forms/ViewForm';
import Tasklists from './components/forms/Tasklists';
import CreateTasklist from './components/forms/CreateTasklist';
import EditTasklist from './components/forms/EditTasklist';
import MyLists from './components/forms/MyLists';
import PrivacyPolicy from './components/legal/PrivacyPolicy';

// Protected Route Component
const ProtectedRoute = ({ children, requiredPermission }) => {
  const { currentUser } = useAuth();
  const { hasPermission } = useAuthorization();
  
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!requiredPermission) {
    return children;
  }
  
  return hasPermission(requiredPermission) ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AuthorizationProvider>
          <Routes>
            <Route element={<RootLayout />}>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Navigate to="/forms" />} />
              <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
              <Route 
                path="dashboard" 
                element={
                  <ProtectedRoute requiredPermission="VIEW_DASHBOARD">
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="forms" 
                element={
                  <ProtectedRoute requiredPermission="VIEW_FORMS">
                    <Forms />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="about" 
                element={
                  <ProtectedRoute requiredPermission="VIEW_ABOUT">
                    <About />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="dashboard" 
                element={
                  <ProtectedRoute requiredPermission="VIEW_REPORTS">
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="forms/:id" 
                element={
                  <ProtectedRoute requiredPermission="EDIT_FORMS">
                    <ViewForm />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="manage" 
                element={
                  <ProtectedRoute requiredPermission="MANAGE_USERS">
                    <Management />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="waste" 
                element={
                  <ProtectedRoute requiredPermission="VIEW_WASTE">
                    <Waste />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="forms/completed/:id" 
                element={
                  <ProtectedRoute requiredPermission="VIEW_FORMS">
                    <ViewForm />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="forms/tasklists" 
                element={
                  <ProtectedRoute requiredPermission="SUBMIT_FORMS">
                    <Tasklists />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="forms/tasklists/create" 
                element={
                  <ProtectedRoute requiredPermission="CREATE_TEMPLATE">
                    <CreateTasklist />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="forms/edit/:templateId" 
                element={
                  <ProtectedRoute requiredPermission="EDIT_TEMPLATE">
                    <EditTasklist />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="forms/tasklists/mylists" 
                element={
                  <ProtectedRoute requiredPermission="VIEW_ASSIGNED_FORMS">
                    <MyLists />
                  </ProtectedRoute>
                } 
              />
            </Route>
          </Routes>
        </AuthorizationProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;